"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var page_margins_html_1 = __importDefault(require("./page-margins.html"));
require("./page-margins.less");
(function (module) {
    'use strict';
    module.directive('prPageMargins', [
        'prEventService',
        'prPageLayoutService',
        function (eventService, pageLayout) {
            function getStyles() {
                var margins = pageLayout.getMargins();
                return _.mapValues(margins, function (val, key) {
                    // shift the top-left over by 1px for perfect alignment
                    return (val - (key === 'top' || key === 'left')) + 'px';
                });
            }
            return {
                scope: false,
                templateUrl: page_margins_html_1.default,
                link: function ($scope, $element) {
                    function setStyles() {
                        $element.children().css(getStyles());
                    }
                    eventService.on('updatePageMargins', setStyles);
                    $element.on('$destroy', function () {
                        eventService.off('updatePageMargins', setStyles);
                    });
                    setStyles();
                }
            };
        }
    ]);
}(angular.module('qualtrics.pr')));
